<template>
  <div
    class="comp tag-item-comp"
    :class="{
      'is-small': isSmall,
      'is-plain': isPlain,
      'is-primary': isPrimary,
      'is-round': isRound,
      'disabled': disabled,
      'auto-width': autoWidth
    }"
    @click="
      () => {
        click(id);
      }
    "
  >
    <span>{{ name }}</span>
  </div>
</template>

<script>
export default {
  name: 'tagItem',
  props: {
    id: {
      type: [Number, String]
    },
    name: {
      type: String
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    isPlain: {
      type: Boolean,
      default: false
    },
    isPrimary: {
      type: Boolean,
      default: false
    },
    isRound: {
      type: Boolean,
      default: false
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    click: {
      type: Function,
      default: function(id) {}
    }
  }
};
</script>
<style lang="stylus" scoped>
.tag-item-comp {
  display: inline-block;
  width: 120px;
  height: 40px;
  border-radius: 6px;
  background-color: #F3F9E9;
  line-height: 40px;
  text-align: center;
  color: #8FC31E;
  font-size: 22px;
  overflow hidden
  text-overflow: ellipsis;
  white-space: nowrap;
  &.auto-width{
    width: auto
    padding: 0 10px
  }

  &.is-small{
    width: 90px;
  }

  &.is-plain {
    border: 1px solid #999;
    color: #999;
    background-color: #fff;
  }

  &.is-primary{
    color: #FFF;
    background-color: #8FC31E;
    border-color: #8FC31E;
  }

  &.is-round{
    border-radius: 20px;
  }

  &.disabled {
    opacity: .5
  }
}
</style>
